function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import BasePlugin from '@uppy/core/lib/BasePlugin.js';
import findDOMElement from '@uppy/utils/lib/findDOMElement';
import toArray from '@uppy/utils/lib/toArray';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore untyped
import getFormData from 'get-form-data';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
var packageJson = {
  "version": "3.2.2"
};
var defaultOptions = {
  resultName: 'uppyResult',
  getMetaFromForm: true,
  addResultToForm: true,
  submitOnSuccess: false,
  triggerUploadOnSubmit: false
};
function assertHTMLFormElement(input) {
  if (input == null || input.nodeName !== 'FORM') {
    throw new Error('ASSERTION FAILED: the target is not a <form> element', {
      cause: input
    });
  }
  return input;
}
var Form = /*#__PURE__*/function (_BasePlugin) {
  _inherits(Form, _BasePlugin);
  // TODO: make this private (or at least, mark it as readonly)

  function Form(uppy, opts) {
    var _this;
    _classCallCheck(this, Form);
    _this = _callSuper(this, Form, [uppy, _objectSpread(_objectSpread({}, defaultOptions), opts)]);
    _this.type = 'acquirer';
    _this.id = _this.opts.id || 'Form';
    _this.handleFormSubmit = _this.handleFormSubmit.bind(_assertThisInitialized(_this));
    _this.handleUploadStart = _this.handleUploadStart.bind(_assertThisInitialized(_this));
    _this.handleSuccess = _this.handleSuccess.bind(_assertThisInitialized(_this));
    _this.addResultToForm = _this.addResultToForm.bind(_assertThisInitialized(_this));
    _this.getMetaFromForm = _this.getMetaFromForm.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Form, [{
    key: "handleUploadStart",
    value: function handleUploadStart() {
      if (this.opts.getMetaFromForm) {
        this.getMetaFromForm();
      }
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(result) {
      if (this.opts.addResultToForm) {
        this.addResultToForm(result);
      }
      if (this.opts.submitOnSuccess) {
        // Returns true if the element's child controls satisfy their validation constraints.
        // When false is returned, cancelable invalid events are fired for each invalid child
        // and validation problems are reported to the user.
        if (this.form.reportValidity()) {
          this.form.submit();
        }
      }
    }
  }, {
    key: "handleFormSubmit",
    value: function handleFormSubmit(ev) {
      var _this2 = this;
      if (this.opts.triggerUploadOnSubmit) {
        ev.preventDefault();
        var elements = toArray(ev.target.elements);
        var disabledByUppy = [];
        elements.forEach(function (el) {
          var isButton = el.tagName === 'BUTTON' || el.tagName === 'INPUT' && el.type === 'submit';
          if (isButton && !el.disabled) {
            ;
            el.disabled = true; // eslint-disable-line no-param-reassign
            disabledByUppy.push(el);
          }
        });
        this.uppy.upload().then(function () {
          disabledByUppy.forEach(function (button) {
            button.disabled = false; // eslint-disable-line no-param-reassign
          });
        }, function (err) {
          disabledByUppy.forEach(function (button) {
            button.disabled = false; // eslint-disable-line no-param-reassign
          });
          return Promise.reject(err);
        }).catch(function (err) {
          _this2.uppy.log(err.stack || err.message || err);
        });
      }
    }
  }, {
    key: "addResultToForm",
    value: function addResultToForm(result) {
      this.uppy.log('[Form] Adding result to the original form:');
      this.uppy.log(result);
      var resultInput = this.form.querySelector("[name=\"".concat(this.opts.resultName, "\"]"));
      if (resultInput) {
        // Append new result to the previous result array.
        // If the previous result is empty, or not an array,
        // set it to an empty array.
        var updatedResult;
        try {
          updatedResult = JSON.parse(resultInput.value);
        } catch (err) {
          // Nothing, since we check for array below anyway
        }
        if (!Array.isArray(updatedResult)) {
          updatedResult = [];
        }
        updatedResult.push(result);
        resultInput.value = JSON.stringify(updatedResult);
        return;
      }
      resultInput = document.createElement('input');
      resultInput.name = this.opts.resultName;
      resultInput.type = 'hidden';
      resultInput.value = JSON.stringify([result]);
      this.form.appendChild(resultInput);
    }
  }, {
    key: "getMetaFromForm",
    value: function getMetaFromForm() {
      var formMeta = getFormData(this.form);
      // We want to exclude meta the the Form plugin itself has added
      // See https://github.com/transloadit/uppy/issues/1637
      delete formMeta[this.opts.resultName];
      this.uppy.setMeta(formMeta);
    }
  }, {
    key: "install",
    value: function install() {
      this.form = assertHTMLFormElement(findDOMElement(this.opts.target));
      this.form.addEventListener('submit', this.handleFormSubmit);
      this.uppy.on('upload', this.handleUploadStart);
      this.uppy.on('complete', this.handleSuccess);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.form.removeEventListener('submit', this.handleFormSubmit);
      this.uppy.off('upload', this.handleUploadStart);
      this.uppy.off('complete', this.handleSuccess);
    }
  }]);
  return Form;
}(BasePlugin);
export { Form as default };
Form.VERSION = packageJson.version;